import { render } from "./GenderPage.vue?vue&type=template&id=2f04c1a9&scoped=true"
import script from "./GenderPage.vue?vue&type=script&lang=js"
export * from "./GenderPage.vue?vue&type=script&lang=js"

import "./GenderPage.vue?vue&type=style&index=0&id=2f04c1a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f04c1a9"]])

export default __exports__